import { type MutationHookOptions, useMutation } from "@apollo/client";
import {
  AddRevenueShareReportCorrectionMutation,
  RecalculateRevenueShareReportMutation,
} from "../graphql/mutations";
import type {
  AddRevenueShareReportCorrectionMutationType,
  AddRevenueShareReportCorrectionMutationVariablesType,
  RecalculateRevenueShareReportMutationType,
  RecalculateRevenueShareReportMutationVariablesType,
} from "@/types/graphql/admin.generated";

export const useAddRevenueShareReportCorrectionMutation = (
  options?: MutationHookOptions<
    AddRevenueShareReportCorrectionMutationType,
    AddRevenueShareReportCorrectionMutationVariablesType
  >
) => {
  return useMutation<
    AddRevenueShareReportCorrectionMutationType,
    AddRevenueShareReportCorrectionMutationVariablesType
  >(AddRevenueShareReportCorrectionMutation, options);
};

export const useRecalculateRevenueShareReportMutation = (
  options?: MutationHookOptions<
    RecalculateRevenueShareReportMutationType,
    RecalculateRevenueShareReportMutationVariablesType
  >
) => {
  return useMutation<
    RecalculateRevenueShareReportMutationType,
    RecalculateRevenueShareReportMutationVariablesType
  >(RecalculateRevenueShareReportMutation, options);
};
